import { useFragment } from 'react-relay';
import { Link as RouterLink } from 'react-router-dom';
import { complexLinkFragment } from './ComplexLink.relay';
import type { ComplexLinkPropsType } from './types';

export const ComplexLink: React.FC<ComplexLinkPropsType> = (props: ComplexLinkPropsType) => {
  const complexLink = useFragment(complexLinkFragment, props.complexLink);

  return (
    <div className={['basis-1/2 mb-8 [&_a]:flex [&_a]:flex-col', props.className].filter(Boolean).join(' ')}>
      {!complexLink.url.match(/^https?:\/\/|\/assets\//) ? (
        <RouterLink to={complexLink.url}>
          <span className="flex justify-between border-b border-black text-xs after:content-['»']">{complexLink.title}</span>
          <span className="text-sm text-black normal-case leading-[20px] tracking-normal">{complexLink.text}</span>
        </RouterLink>
      ) : (
        <a href={complexLink.url} target="_blank" rel="noreferrer">
          <span className="flex justify-between border-b border-black after:content-['»'] text-accent">{complexLink.title}</span>
          <span className="text-sm text-black normal-case leading-[20px] tracking-normal">{complexLink.text}</span>
        </a>
      )}
    </div>
  );
};
